import React, {useEffect, useRef, useState} from 'react';
import {Container, FormControlLabel, Grid, InputLabel, NativeSelect, Select} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AccountCircle from '@material-ui/icons/AccountCircle';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ExitToAppSharpIcon from '@material-ui/icons/ExitToAppSharp';
import CircularProgress from '@material-ui/core/CircularProgress';
import {useHistory, useLocation} from "react-router-dom";
import customer_api, {SetDefaultUrl, SetGClubUrl} from "../api/customer_api";
import { useGlobalStore } from "../store/GlobalContext";
import localStorage from "../store/LocalStorage";
import { setAxiosHeaderAuthorization } from '../api/axios_client'
import NewsModal from "../components/Modal/NewsModal";
import Visibility from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import {Controller, useForm} from "react-hook-form";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

const useStyles = makeStyles( ( theme ) => ( {
    rootX: {
        width: '100%',
        color:'red',
    },
    select: {
        backgroundColor: '#000000',
        color: `#FFFFFF`,
        '&:select': {
            color: `#FF0000`,
            // backgroundColor:`transparent`
        },
        '&:hover': {
            color: `#000000`,
            backgroundColor: 'transparent',
        },
        '&:focus': {
            color: `#FF0000`,
            // backgroundColor:`transparent`
        },
    },
    selectDropdown: {
        borderColor: `${process.env.REACT_APP_PRIMARY_THEME_COLOR}`,
        border:"1px solid",
        borderRadius:"2px",
        '& .MuiSvgIcon-root':{
            color:`${process.env.REACT_APP_PRIMARY_THEME_COLOR}`
        }
    },
    dropdownStyle:
        {
            border: "1px solid black",
            borderRadius: "5%",
            backgroundColor:'lightgrey',
        },
} ) );

export default function LoginPage () {
    let history = useHistory();
    const [ , dispatch ] = useGlobalStore()
    const [ lineUrl, setLineUrl ] = useState( "https://www.google.com" )
    const [ isLoading, setIsLoading ] = useState( false )
    const [ lineAvailable, setLineAvailable ] = useState( false )
    const [ welcomeImages, setWelcomeImages ] = useState( [] )
    const [ welcomeModal, setWelcomeModal ] = useState( false )
    const [ showPassword, setShowPassword ] = useState( false )
    const [ maintenanceMode, setMaintenanceMode ] = useState( false )

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        getValues,
        setValue,
    } = useForm({
        defaultValues:{
            "selected_agent": process.env.REACT_APP_DEFAULT_AGENT,
            agent_dropdown_enable: false,
            agent_dropdown_list:[
                {key: "กรุณาเลือกเอเย่นต์", value:""}
            ]
        },
        shouldUnregister:false
    })

    const classes = useStyles();

    const mapAgents = [
        {value:"",key: "กรุณาเลือกเอเย่นต์"},
        {value:"ufa",key: "ยูฟ่า"},
        {value:"gclub",key: "จีคลับ"}
        // "918kiss": "918คิส",
        // "pussy888": "พุซซี่888",
    ];

    const handleClickShowPassword = () => {
        setShowPassword( !showPassword );
    };

    const handleMouseDownPassword = ( event ) => {
        event.preventDefault();
    };

    const LineIcon = () => (
        <img alt="line-logo" src="line.svg" style={{ height: "30px" }}/>
    )

    const onSubmit = async request => {

        const requestData = {
            username: request.username,
            password: request.password,
            agent_name: process.env.REACT_APP_LOGIN_AGENT_NAME,
            selected_agent: request.selected_agent,
        }

        // console.log("request.username.match( /^[0-9]+$/ ): ", request.username.match( /^[0-9]+$/ ))
        if(request.username.match( /^[0-9]+$/ ) === null){
            requestData.selected_agent = ""
            }

        console.log("on submit requestData: ", requestData)

        setIsLoading( true );
        try{
            const response = await customer_api.CUSTOMER_LOGIN_WITH_PASSWORD(requestData)
            const { data } = response.data
            const news = { news: welcomeImages }
            const dataWithNews = { ...data, news }

            localStorage.setAllAccess( { ...dataWithNews } );
            setAxiosHeaderAuthorization( localStorage.getAccessToken() )
            dispatch( { type: 'login_profile', payload: { data: dataWithNews } } )
            history.push( '/content' )
            // console.log("get access obj in content: ", localStorage.getAllAccess())
        } catch(error) {
            console.log("error: ", error)
            const errorMessage = error.response
            if ( errorMessage === undefined ) {
                dispatch( {
                    type: 'error_message_dialog',
                    payload: { data: `ขออภัยระบบไม่สามารถดำเนินการได้ กรุณาลองใหม่ภายหลัง` }
                } )
            } else {
                dispatch( { type: 'error_message_dialog', payload: { data: `${error.response.data.message} (${error.response.data.code || ""})` }} )
            }
        }finally{
            setIsLoading( false )
        }
    }

    useEffect( async () => {
        localStorage.removeAllAccess()
        const request = {
            "agent_name": process.env.REACT_APP_LOGIN_AGENT_NAME,
            "money_site_name": process.env.REACT_APP_MONEY_SITE_NAME
        }
        try{
            const response = await customer_api.GET_LINE_ID( request )
            const { data } = response.data
            // console.log("get_line_id:", data)

            let agentMap = []
            mapAgents.forEach(function (item) {
                if ( data.agents.indexOf(item.value) !== -1){
                    agentMap.push({key:item.key, value: item.value})
                }
            });

            setValue("agent_dropdown_list", agentMap)
            //
            setValue("selected_agent", process.env.REACT_APP_DEFAULT_AGENT)
            const news = data.news

            setLineUrl( data.line_url )
            setLineAvailable( true )

            if ( news !== null && news.length > 0 ) {
                let images = news.filter( data => data.enable === true );

                if ( images !== null && images.length > 0 ) {
                    setWelcomeImages( images )
                    setWelcomeModal( true )
                }
            }

            if ( data.maintenance === undefined ) {
                setMaintenanceMode( false )
            } else {
                setMaintenanceMode( data.maintenance )
            }

        } catch(error){
            const errorMessage = error.response
            //console.log( error )
            if ( errorMessage === undefined ) {
                dispatch( {
                    type: 'error_message_dialog',
                    payload: { data: "ขออภัยระบบไม่สามารถดำเนินการได้ กรุณาลองใหม่ภายหลัง" }
                } )
            } else {
                dispatch( { type: 'error_message_dialog', payload: { data: `${error.response.data.message} (${error.response.data.code || ""})` }} )
            }
        }
    }, [] )

    const watchUsername = watch("username")
    const watchSelectAgent = watch("selected_agent")

    useEffect(()=>{

        // console.log(watchUsername?.match( /^[0-9]+$/ ))
        if(watchUsername?.match( /^[0-9]+$/ ) !== null && getValues("agent_dropdown_list").length > 1){
            setValue("agent_dropdown_enable", true)
        }else{
            setValue("agent_dropdown_enable", false)
        }

    },[watchUsername])

    return (
        <form noValidate={false} onSubmit={handleSubmit(onSubmit)}>
            <NewsModal openModal={welcomeModal} images={welcomeImages} onClose={() => setWelcomeModal( false )}
                       enableClose={maintenanceMode}/>
            <Container>
                <Grid container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      spacing={2}
                >
                    <Grid item xs={10} md={4} xl={4}>
                        <a href={`${window.location.origin.replace("customer.", "")}`} target="_blank" rel="noopener noreferrer">
                            <img src={process.env.REACT_APP_LOGO_PATH} alt={process.env.REACT_APP_MONEY_SITE_NAME}
                                 height="100"/>
                        </a>
                    </Grid>
                    <Grid item xs={10} md={4} xl={4} style={{ width: '100%' }}>
                        {/*<TextBoxGold label={"username"} type={"text"} placeholder={"ufyu88800001"}/>*/}
                        <h1 style={{display: 'none'}}>หน้าเข้าสู่ระบบสมาชิก</h1>
                        <TextField id="outlined-username" label="รหัสลูกค้า/เบอร์มือถือ" variant="outlined" focused
                                   style={{ width: '100%' }}
                                   InputProps={{
                                       startAdornment: (
                                           <InputAdornment position="start">
                                               <AccountCircle color={"primary"}/>
                                           </InputAdornment>
                                       ),
                                   }}
                                   name="username"
                                   error={errors.username}
                                   placeholder={"กรุณาระบุรหัสลูกค้า"}
                                   helperText={errors.username && "*รหัสลูกค้า อย่างน้อย 7 ตัว/เบอร์มือถือ 10 ตัว"}
                                   {...register('username',
                                       {
                                           required: true,
                                           minLength:7,
                                           onBlur:(e)=> setValue('username', e.target.value.trim())
                                       })
                                   }
                        />

                    </Grid>
                    <Grid item xs={10} md={4} xl={4} style={{ width: '100%' }}>
                        <TextField id="outlined-password" label="รหัสผ่าน" variant="outlined" focused
                                   style={{ width: '100%' }}
                                   type={showPassword ? 'text' : 'password'}
                                   InputProps={{
                                       startAdornment: (
                                           <InputAdornment position="start">
                                               <VpnKeyIcon color={"primary"}/>
                                           </InputAdornment>
                                       ),
                                       endAdornment: (
                                           <InputAdornment position="end">
                                               <IconButton
                                                   aria-label="toggle password visibility"
                                                   onClick={handleClickShowPassword}
                                                   onMouseDown={handleMouseDownPassword}
                                                   edge="end"
                                               >
                                                   {showPassword ? <Visibility color={"primary"}/> :
                                                       <VisibilityOff color={"primary"}/>}
                                               </IconButton>
                                           </InputAdornment>
                                       )
                                   }}
                                   name="password"
                                   error={errors.password}
                                   placeholder={"กรุณาระบุรหัสผ่าน"}
                                   helperText={errors.password && "กรุณาระบุรหัสผ่าน"}
                                   {...register('password',{required:true})}
                        />
                    </Grid>
                    {
                        (getValues("agent_dropdown_enable") === true) &&
                        <Grid item xs={10} md={4} xl={4} style={{ width: '100%' }}>
                            <Select
                                fullWidth
                                native
                                id="outlined-selected-agent-input"
                                name="selected_agent"
                                // label="เลือก Agent"
                                // style={{ color: "red", width:'100%', border:"2px", borderColor:`${process.env.REACT_APP_PRIMARY_THEME_COLOR}` }}
                                // color={"primary"}

                                variant="outlined"
                                defaultValue={getValues("agent_dropdown_list")[0]}
                                helperText={errors.selected_agent && "*กรุณาเลือก Agent"}
                                className={classes.selectDropdown}
                                {...register('selected_agent',{required:true})}
                            >
                                {
                                    getValues("agent_dropdown_list")?.map( ( ag) => (
                                        <option key={ag.value} value={ag.value} >
                                            {ag.key}
                                        </option>
                                    ))
                                }
                            </Select>
                            <FormHelperText error={errors.selected_agent}>*กรุณาเลือก Agent</FormHelperText>
                        </Grid>
                    }
                    <Grid item xs={10} md={4} xl={4} style={{ width: '100%' }}>
                        <Button
                            type={"submit"}
                            startIcon={isLoading ? ( <CircularProgress color="inherit" size={20}/> ) : (
                                <ExitToAppSharpIcon/> )}
                            variant={"contained"}
                            color={"primary"} style={{ width: '100%' }} size={"large"}
                            // onClick={onSubmit}
                        >เข้าสู่ระบบ</Button>
                    </Grid>
                    {
                        ( lineAvailable ) ?
                            ( <Grid item xs={10} md={4} xl={4} style={{ width: '100%' }}>
                                <Button startIcon={<LineIcon/>} variant={"contained"}
                                        style={{ width: '100%', backgroundColor: "#39b220" }} size={"large"}
                                        onClick={() => window.open( lineUrl, "_blank" )}>
                                    Line Support
                                </Button>
                            </Grid> ) : ( <></> )
                    }
                </Grid>
            </Container>
        </form>
    )
}